import { GetB2bOperationErOneResponse } from '@Common/types/bo/b2b/operations_er';

import { makeChoicesCommon } from '@sh4res/bo-common/utils';

export const b2bOperationErNatureChoices = makeChoicesCommon<
  GetB2bOperationErOneResponse['operation_nature']
>()({
  MV: 'resources.bo_common.b2b.operations_er.choices.nature.MV',
  AN: 'resources.bo_common.b2b.operations_er.choices.nature.AN',
  IM: 'resources.bo_common.b2b.operations_er.choices.nature.IM',
});

export const b2bOperationErTypeChoices = makeChoicesCommon<
  GetB2bOperationErOneResponse['operation_type']
>()({
  ABONDEMENT: 'resources.bo_common.b2b.operations_er.choices.type.ABONDEMENT',
  ABONDEMENT_COLL: 'resources.bo_common.b2b.operations_er.choices.type.ABONDEMENT_COLL',
  ABONDEMENT_DES: 'resources.bo_common.b2b.operations_er.choices.type.ABONDEMENT_DES',
  ABONDEMENT_INV: 'resources.bo_common.b2b.operations_er.choices.type.ABONDEMENT_INV',
  AFF_ABONDE: 'resources.bo_common.b2b.operations_er.choices.type.AFF_ABONDE',
  AFF_COT: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT',
  AFF_COT_E: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_E',
  AFF_COT_EXO: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_EXO',
  AFF_COT_RATT: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_RATT',
  AFF_COT_RATT_E: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_RATT_E',
  AFF_COT_RATT_S: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_RATT_S',
  AFF_COT_S: 'resources.bo_common.b2b.operations_er.choices.type.AFF_COT_S',
  AFF_INTERESS: 'resources.bo_common.b2b.operations_er.choices.type.AFF_INTERESS',
  AFF_PARTICIP: 'resources.bo_common.b2b.operations_er.choices.type.AFF_PARTICIP',
  AFF_PPV: 'resources.bo_common.b2b.operations_er.choices.type.AFF_PPV',
  AFF_PPVE: 'resources.bo_common.b2b.operations_er.choices.type.AFF_PPVE',
  AFF_VERS_CET: 'resources.bo_common.b2b.operations_er.choices.type.AFF_VERS_CET',
  ARB: 'resources.bo_common.b2b.operations_er.choices.type.ARB',
  ARB_ATT: 'resources.bo_common.b2b.operations_er.choices.type.ARB_ATT',
  ARB_ATT_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_ATT_DES',
  ARB_ATT_EST_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_ATT_EST_DES',
  ARB_ATT_EST_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_ATT_EST_INV',
  ARB_ATT_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_ATT_INV',
  ARB_AU_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_AU_DES',
  ARB_AU_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_AU_INV',
  ARB_CATT_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_CATT_DES',
  ARB_CATT_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_CATT_INV',
  ARB_CO: 'resources.bo_common.b2b.operations_er.choices.type.ARB_CO',
  ARB_CO_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_CO_DES',
  ARB_CO_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_CO_INV',
  ARB_COM: 'resources.bo_common.b2b.operations_er.choices.type.ARB_COM',
  ARB_COM_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_COM_DES',
  ARB_COM_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_COM_INV',
  ARB_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_DES',
  ARB_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_INV',
  ARB_PSAP_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_PSAP_DES',
  ARB_PSAP_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_PSAP_INV',
  ARB_REBAL_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_REBAL_DES',
  ARB_REBAL_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_REBAL_INV',
  ARB_SECU_DES: 'resources.bo_common.b2b.operations_er.choices.type.ARB_SECU_DES',
  ARB_SECU_INV: 'resources.bo_common.b2b.operations_er.choices.type.ARB_SECU_INV',
  AVANCE_FDS_RLMT: 'resources.bo_common.b2b.operations_er.choices.type.AVANCE_FDS_RLMT',
  CC_REVALO: 'resources.bo_common.b2b.operations_er.choices.type.CC_REVALO',
  CC_REVALO_39: 'resources.bo_common.b2b.operations_er.choices.type.CC_REVALO_39',
  COM_FDS_COLL: 'resources.bo_common.b2b.operations_er.choices.type.COM_FDS_COLL',
  COTI_ANTIC: 'resources.bo_common.b2b.operations_er.choices.type.COTI_ANTIC',
  COTI_EXCEP: 'resources.bo_common.b2b.operations_er.choices.type.COTI_EXCEP',
  COTI_RATT: 'resources.bo_common.b2b.operations_er.choices.type.COTI_RATT',
  COTI_RATT_E: 'resources.bo_common.b2b.operations_er.choices.type.COTI_RATT_E',
  COTI_RATT_S: 'resources.bo_common.b2b.operations_er.choices.type.COTI_RATT_S',
  COTI_REGUL: 'resources.bo_common.b2b.operations_er.choices.type.COTI_REGUL',
  COTIS: 'resources.bo_common.b2b.operations_er.choices.type.COTIS',
  COTIS_DES: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_DES',
  COTIS_E: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_E',
  COTIS_ESTIM: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_ESTIM',
  COTIS_ESTIM_N: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_ESTIM_N',
  COTIS_EXO: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_EXO',
  COTIS_EXO_INV: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_EXO_INV',
  COTIS_INV: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_INV',
  COTIS_S: 'resources.bo_common.b2b.operations_er.choices.type.COTIS_S',
  D_TR_E_C_E: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_E',
  D_TR_E_C_E_DES: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_E_DES',
  D_TR_E_C_E_INV: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_E_INV',
  D_TR_E_C_I: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_I',
  D_TR_E_C_I_DES: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_I_DES',
  D_TR_E_C_I_INV: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_E_C_I_INV',
  D_TR_S_C_E: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_S_C_E',
  D_TR_S_C_I: 'resources.bo_common.b2b.operations_er.choices.type.D_TR_S_C_I',
  DC_ACTIF_39: 'resources.bo_common.b2b.operations_er.choices.type.DC_ACTIF_39',
  DECES_ACTIF: 'resources.bo_common.b2b.operations_er.choices.type.DECES_ACTIF',
  DC_PREST: 'resources.bo_common.b2b.operations_er.choices.type.DC_PREST',
  DC_REGL: 'resources.bo_common.b2b.operations_er.choices.type.DC_REGL',
  FISCALITE: 'resources.bo_common.b2b.operations_er.choices.type.FISCALITE',
  FR_CPT_ENT: 'resources.bo_common.b2b.operations_er.choices.type.FR_CPT_ENT',
  FR_CPT_SOUS: 'resources.bo_common.b2b.operations_er.choices.type.FR_CPT_SOUS',
  FR_DC_EU: 'resources.bo_common.b2b.operations_er.choices.type.FR_DC_EU',
  FR_DC_UC: 'resources.bo_common.b2b.operations_er.choices.type.FR_DC_UC',
  FR_ENC_MIN: 'resources.bo_common.b2b.operations_er.choices.type.FR_ENC_MIN',
  FR_EU: 'resources.bo_common.b2b.operations_er.choices.type.FR_EU',
  FR_EU_COMPL: 'resources.bo_common.b2b.operations_er.choices.type.FR_EU_COMPL',
  FR_EU_REDUC: 'resources.bo_common.b2b.operations_er.choices.type.FR_EU_REDUC',
  FR_FCL: 'resources.bo_common.b2b.operations_er.choices.type.FR_FCL',
  FR_GAR_PLAN: 'resources.bo_common.b2b.operations_er.choices.type.FR_GAR_PLAN',
  FR_PRIME: 'resources.bo_common.b2b.operations_er.choices.type.FR_PRIME',
  FR_REDUC: 'resources.bo_common.b2b.operations_er.choices.type.FR_REDUC',
  FR_RENTE: 'resources.bo_common.b2b.operations_er.choices.type.FR_RENTE',
  FR_TABLE_EU: 'resources.bo_common.b2b.operations_er.choices.type.FR_TABLE_EU',
  FR_TABLE_UC: 'resources.bo_common.b2b.operations_er.choices.type.FR_TABLE_UC',
  FR_UC: 'resources.bo_common.b2b.operations_er.choices.type.FR_UC',
  FR_UC_COMPL: 'resources.bo_common.b2b.operations_er.choices.type.FR_UC_COMPL',
  INTERESS_DES: 'resources.bo_common.b2b.operations_er.choices.type.INTERESS_DES',
  INTERESS_EXCEPT: 'resources.bo_common.b2b.operations_er.choices.type.INTERESS_EXCEPT',
  INTERESS_INV: 'resources.bo_common.b2b.operations_er.choices.type.INTERESS_INV',
  INTERESS_REGUL: 'resources.bo_common.b2b.operations_er.choices.type.INTERESS_REGUL',
  INTERESSEMENT: 'resources.bo_common.b2b.operations_er.choices.type.INTERESSEMENT',
  NANTISSEMENT: 'resources.bo_common.b2b.operations_er.choices.type.NANTISSEMENT',
  OST_DDC: 'resources.bo_common.b2b.operations_er.choices.type.OST_DDC',
  OST_FA_DES: 'resources.bo_common.b2b.operations_er.choices.type.OST_FA_DES',
  OST_FA_INV: 'resources.bo_common.b2b.operations_er.choices.type.OST_FA_INV',
  PAR: 'resources.bo_common.b2b.operations_er.choices.type.PAR',
  PARTICIP_DES: 'resources.bo_common.b2b.operations_er.choices.type.PARTICIP_DES',
  PARTICIP_EXCEPT: 'resources.bo_common.b2b.operations_er.choices.type.PARTICIP_EXCEPT',
  PARTICIP_INV: 'resources.bo_common.b2b.operations_er.choices.type.PARTICIP_INV',
  PARTICIP_REGUL: 'resources.bo_common.b2b.operations_er.choices.type.PARTICIP_REGUL',
  PARTICIPATION: 'resources.bo_common.b2b.operations_er.choices.type.PARTICIPATION',
  PB: 'resources.bo_common.b2b.operations_er.choices.type.PB',
  PB_FDS_RENTE: 'resources.bo_common.b2b.operations_er.choices.type.PB_FDS_RENTE',
  PB_GAR_CAPITAL: 'resources.bo_common.b2b.operations_er.choices.type.PB_GAR_CAPITAL',
  PERT_TECH_39: 'resources.bo_common.b2b.operations_er.choices.type.PERT_TECH_39',
  PM_AJUST: 'resources.bo_common.b2b.operations_er.choices.type.PM_AJUST',
  PPV: 'resources.bo_common.b2b.operations_er.choices.type.PPV',
  PPV_DES: 'resources.bo_common.b2b.operations_er.choices.type.PPV_DES',
  PPV_E: 'resources.bo_common.b2b.operations_er.choices.type.PPV_E',
  PPV_INV: 'resources.bo_common.b2b.operations_er.choices.type.PPV_INV',
  PPVE_DES: 'resources.bo_common.b2b.operations_er.choices.type.PPVE_DES',
  PPVE_INV: 'resources.bo_common.b2b.operations_er.choices.type.PPVE_INV',
  PRA: 'resources.bo_common.b2b.operations_er.choices.type.PRA',
  PREST_39: 'resources.bo_common.b2b.operations_er.choices.type.PREST_39',
  PREST_CC: 'resources.bo_common.b2b.operations_er.choices.type.PREST_CC',
  PREST_FILLON: 'resources.bo_common.b2b.operations_er.choices.type.PREST_FILLON',
  PREST_IFC: 'resources.bo_common.b2b.operations_er.choices.type.PREST_IFC',
  PREST_IL: 'resources.bo_common.b2b.operations_er.choices.type.PREST_IL',
  PRLV_FISC: 'resources.bo_common.b2b.operations_er.choices.type.PRLV_FISC',
  PRLV_FISC_OBLIG: 'resources.bo_common.b2b.operations_er.choices.type.PRLV_FISC_OBLIG',
  PRLV_SOC: 'resources.bo_common.b2b.operations_er.choices.type.PRLV_SOC',
  PRST_CHARGE_SOC: 'resources.bo_common.b2b.operations_er.choices.type.PRST_CHARGE_SOC',
  PRST_EXECEPTION: 'resources.bo_common.b2b.operations_er.choices.type.PRST_EXECEPTION',
  PSAP: 'resources.bo_common.b2b.operations_er.choices.type.PSAP',
  PSAP_EA: 'resources.bo_common.b2b.operations_er.choices.type.PSAP_EA',
  PSAP_PREST: 'resources.bo_common.b2b.operations_er.choices.type.PSAP_PREST',
  PVP: 'resources.bo_common.b2b.operations_er.choices.type.PVP',
  RB_PRLV_SOC: 'resources.bo_common.b2b.operations_er.choices.type.RB_PRLV_SOC',
  RBT_CARENCE_39: 'resources.bo_common.b2b.operations_er.choices.type.RBT_CARENCE_39',
  RBT_CARENCE: 'resources.bo_common.b2b.operations_er.choices.type.RBT_CARENCE',
  REG_ACTIF: 'resources.bo_common.b2b.operations_er.choices.type.REG_ACTIF',
  REG_PASSIF: 'resources.bo_common.b2b.operations_er.choices.type.REG_PASSIF',
  REGLE_COM_ENC: 'resources.bo_common.b2b.operations_er.choices.type.REGLE_COM_ENC',
  REGLE_COM_MVT: 'resources.bo_common.b2b.operations_er.choices.type.REGLE_COM_MVT',
  REMB_FDS_RLMT: 'resources.bo_common.b2b.operations_er.choices.type.REMB_FDS_RLMT',
  REX: 'resources.bo_common.b2b.operations_er.choices.type.REX',
  RP: 'resources.bo_common.b2b.operations_er.choices.type.RP',
  RPP: 'resources.bo_common.b2b.operations_er.choices.type.RPP',
  RT: 'resources.bo_common.b2b.operations_er.choices.type.RT',
  SOR_CAPITAL: 'resources.bo_common.b2b.operations_er.choices.type.SOR_CAPITAL',
  SOR_CAPITAL_ENT: 'resources.bo_common.b2b.operations_er.choices.type.SOR_CAPITAL_ENT',
  SOR_RENTE: 'resources.bo_common.b2b.operations_er.choices.type.SOR_RENTE',
  SOR_RENTE_ENT: 'resources.bo_common.b2b.operations_er.choices.type.SOR_RENTE_ENT',
  SOR_RENTE_UNIQ: 'resources.bo_common.b2b.operations_er.choices.type.SOR_RENTE_UNIQ',
  T_PEP: 'resources.bo_common.b2b.operations_er.choices.type.T_PEP',
  TMG: 'resources.bo_common.b2b.operations_er.choices.type.TMG',
  TR_E_C_I_STOCK: 'resources.bo_common.b2b.operations_er.choices.type.TR_E_C_I_STOCK',
  TR_ENT_C_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_C_E',
  TR_ENT_C_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_C_I',
  TR_ENT_C_RENTE: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_C_RENTE',
  TR_ENT_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_E',
  TR_ENT_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_I',
  TR_ENT_I_STOCK: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENT_I_STOCK',
  TR_ENTR_EXC_REV: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENTR_EXC_REV',
  TR_ENTR_REVALO: 'resources.bo_common.b2b.operations_er.choices.type.TR_ENTR_REVALO',
  TR_SOR: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR',
  TR_SOR_C_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_C_E',
  TR_SOR_C_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_C_I',
  TR_SOR_C_P_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_C_P_E',
  TR_SOR_C_P_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_C_P_I',
  TR_SOR_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_E',
  TR_SOR_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_I',
  TR_SOR_PAR_C_E: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_PAR_C_E',
  TR_SOR_PAR_C_I: 'resources.bo_common.b2b.operations_er.choices.type.TR_SOR_PAR_C_I',
  TR_SORT_REVALO: 'resources.bo_common.b2b.operations_er.choices.type.TR_SORT_REVALO',
  TR_TECHNIQUE: 'resources.bo_common.b2b.operations_er.choices.type.TR_TECHNIQUE',
  V1: 'resources.bo_common.b2b.operations_er.choices.type.V1',
  VERS_CET: 'resources.bo_common.b2b.operations_er.choices.type.VERS_CET',
  VERS_CET_DES: 'resources.bo_common.b2b.operations_er.choices.type.VERS_CET_DES',
  VERS_CET_INV: 'resources.bo_common.b2b.operations_er.choices.type.VERS_CET_INV',
  VERS_CET_REGUL: 'resources.bo_common.b2b.operations_er.choices.type.VERS_CET_REGUL',
  VL: 'resources.bo_common.b2b.operations_er.choices.type.VL',
  VL_ENT: 'resources.bo_common.b2b.operations_er.choices.type.VL_ENT',
  VL_GRA: 'resources.bo_common.b2b.operations_er.choices.type.VL_GRA',
  VP: 'resources.bo_common.b2b.operations_er.choices.type.VP',
  VP_ENT: 'resources.bo_common.b2b.operations_er.choices.type.VP_ENT',
});
